import service from './axios';

export default {
  // 获取店员操作日志列表
  getClerkLogs(params) {
    return service({
      method: 'get',
      url: '/manage/clerk-logs',
      params,
    });
  },

  // 获取店员操作日志详情
  getClerkLogDetail(id) {
    return service({
      method: 'get',
      url: `/manage/clerk-logs/${id}`,
    });
  },
};
